import { render, staticRenderFns } from "./TabCobrancaGerada.vue?vue&type=template&id=c830c250&"
import script from "./TabCobrancaGerada.vue?vue&type=script&lang=ts&"
export * from "./TabCobrancaGerada.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports